import { LanguageSwitcher } from '@/components/features/i18n/language-switcher';
import { Breadcrumb } from '@/components/shared/breadcrumb';
import { useAuth } from '@/hooks/use-auth';
import { UserMenu } from '@/components/features/auth';

/**
 * Application header.
 * Top row: product name (center), language + profile icon + username (right).
 * Second row: breadcrumb path.
 *
 * @see Spec 0012 Section 7.1 - App Shell Layout
 * @see Spec 110 — Breadcrumbs im Header
 */
export function Header() {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-card">
      {/* Brand accent line — 3px lime stripe at the very top */}
      <div className="h-[3px] bg-brand-accent" />

      {/* Top row — height synced via CSS var --header-top-height */}
      <div className="flex h-[var(--header-top-height)] items-center border-b px-4 md:px-6">
        {/* Left spacer for mobile menu button */}
        <div className="w-10 md:w-0" />

        {/* Center — product name (prominent) */}
        <div className="flex-1 text-center">
          <span className="text-lg font-semibold tracking-wide text-foreground/80">
            Payment Gateway Facade
          </span>
        </div>

        {/* Right — language, profile icon, username below */}
        <div className="flex flex-col items-end gap-0.5">
          <div className="flex items-center gap-2">
            <LanguageSwitcher />
            <UserMenu />
          </div>
          {user && (
            <span className="hidden text-[10px] text-muted-foreground md:inline">
              {user.email}
            </span>
          )}
        </div>
      </div>

      {/* Breadcrumb row */}
      <div className="border-t border-border/40 px-4 py-1.5 md:px-6">
        <Breadcrumb />
      </div>
    </header>
  );
}
